import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import { router } from './plugins/router'
import vuetify from './plugins/vuetify'
import '@/utils/setup'

createApp(App)
  .use(createPinia())
  .use(vuetify)
  .use(router)
  .mount('#app')
